export default __webpack_public_path__ + "../staticImages/apple-touch-icon.png";